var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "relative-position full-height" },
    [
      _c("q-card-title", [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.from_home ? _vm.$t("questions") : _vm.$t(this.type_chat)
            ) +
            "\n    "
        )
      ]),
      _c("q-card-separator"),
      _c(
        "q-card-main",
        { style: _vm.from_home ? _vm.getStyleMain : "" },
        [
          _c(
            "q-scroll-area",
            { style: _vm.from_home ? _vm.getStyleScroll : "height: 400px;" },
            _vm._l(_vm.chats, function(chat, index) {
              return _c("q-chat-message", {
                key: index,
                attrs: {
                  name: chat.n,
                  text: [chat.m],
                  stamp: _vm.fDate(chat.t.toDate()),
                  "bg-color": !chat.a ? _vm.colors[index % 6] : "tertiary",
                  "text-color": "white",
                  sent: chat.a ? true : false
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.actOnChat(chat)
                  }
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _c(
        "q-inner-loading",
        { attrs: { visible: !_vm.loaded } },
        [_c("q-spinner-dots", { attrs: { size: 60, color: "secondary" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }